import { render, staticRenderFns } from "./SessionClosedAlertModal.vue?vue&type=template&id=1390c810&scoped=true"
import script from "./SessionClosedAlertModal.vue?vue&type=script&lang=js"
export * from "./SessionClosedAlertModal.vue?vue&type=script&lang=js"
import style0 from "./SessionClosedAlertModal.vue?vue&type=style&index=0&id=1390c810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390c810",
  null
  
)

export default component.exports